import { Download, FileText } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Type } from "@shared/ui/Type";
import { FileInfo } from "@platform/types/dashboard.types";

export type Props = {
  file: FileInfo;
};

export function DownloadableAssetFile({ file }: Props) {
  return (
    <div className="p-4 rounded-md border border-brand-800 flex flex-row items-center justify-between">
      <div className="flex items-center">
        <FileText className="mr-2 text-brand-600" size={20} />
        <div>
          <Type variant="h5" className="text-brand-700">
            {file.name}
          </Type>
          <Type variant="caption" className="text-brand-700">
            {file.type}
            {file.size && ` · ${file.size}`}
            {file.date && ` · ${file.date}`}
          </Type>
        </div>
      </div>

      <Button
        as="a"
        href={file.downloadUrl}
        target="_blank"
        download
        title="Download"
        aria-label="Download"
        variant="secondary"
        iconComponent={Download}
        data-testid="downloadable-asset-file-download"
      >
        Download
      </Button>
    </div>
  );
}

export default DownloadableAssetFile;
